const BASE_TARGET_TRIAL_URL =
  "https://app.dealfront.com/f/sign/up/start?source=target";

export function getTargetTrialUrl(email) {
  if (!email) return BASE_TARGET_TRIAL_URL;
  try {
    const u = new URL(BASE_TARGET_TRIAL_URL);
    u.searchParams.set("email", email);
    return u.toString();
  } catch (_) {
    // Fallback: simple string append
    return BASE_TARGET_TRIAL_URL + "&email=" + encodeURIComponent(email);
  }
}

export { BASE_TARGET_TRIAL_URL as TARGET_TRIAL_URL };
